<script setup>
const btnTopShow = ref(false)
onMounted(() => window.addEventListener('scroll', handleScroll))

const toTop = () => scrollTo({top: 0, behavior: 'smooth'})
const handleScroll = () => btnTopShow.value = window.scrollY > 200
</script>


<template>
  <main class="min-h-screen w-full pb-24">
    <div class="container mx-auto px-3">
      <slot></slot>
    </div>

    <div
      class="fixed hidden sm:flex flex-col bottom-10 right-3 sm:right-5 lg:right-10 gap-4 transition- duration-300"
      :class="btnTopShow ? 'opacity-100' : 'opacity-0 invisible'"
    >
      <button
        type="button"
        class="inline-flex flex-col items-center gap-2"
        @click="toTop"
      >
        <icon icon="carbon:up-to-top" width="30" />
        <span class="vertical-lr text-xl font-noto-serif">PAGE TOP</span>
      </button>
      <!--
        <button type="button" class="btn btn-circle shadow-lg bg-white">
          <NuxtImg src="/icon/bell.png" width="60px" />
        </button>
      -->
    </div>

    <div
      class="bg-white/30 backdrop-blur w-14 h-14 rounded-lg shadow-lg !fixed flex sm:hidden items-center justify-center bottom-20 right-3 z-[990]"
      :class="[
        'transition- duration-300',
        btnTopShow ? 'opacity-100' : 'opacity-0 invisible'
      ]"
    >
      <button
        type="button"
        class="flex flex-col"
        @click="toTop"
      >
        <icon icon="carbon:up-to-top" width="30" />
        <p class="w-full text-xs text-center -mt-1 font-noto-serif">TOP</p>
      </button>
    </div>
  </main>
</template>